import { Injectable } from '@angular/core';

export type StorageKeys = 'logout-at' | 'session-exp' | 'auth:return-url';

@Injectable({ providedIn: 'root' })
export class AppStorageService {
  read(key: StorageKeys): string {
    return localStorage.getItem(key);
  }

  write(key: StorageKeys, value: any): void {
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }

    localStorage.setItem(key, value);
  }

  remove(key: StorageKeys): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
